// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, intlShape } from 'react-intl';
import { getLocalizedCountry } from '../../../local-values/utils/countries';
import classNames from 'classnames/bind';

import style from './ScrapInputBlock.scss';
import inputStyle from '../../../../assets/styles/input.scss';
import buttonStyle from '../../../../assets/styles/button.scss';
import icons from '../../../../assets/styles/icons.scss';
import amazonLogo from '../../../../assets/img/new-order/search-step/amazon.png';

import type { OnlineStore } from '../../../../entities';
import type { LocaleState } from '../../../locale/duck';
import type { LocalValuesState } from '../../../local-values/duck';

type Props = {
  +handleClickButton: (url: string) => void;
  +store?: OnlineStore;
  +locale: LocaleState;
  +localValues: LocalValuesState;
};

type State = {
  url: {
    value: string;
    errors?: string[];
  };
};

const messages = defineMessages({
  titlePartOne: {
    id: 'store.scrapInputBlock.title.partOne',
  },
  titlePartTwo: {
    id: 'store.scrapInputBlock.title.partTwo',
  },
});

export default class ScrapInputBlock extends Component<Props, State> {
  state = {
    url: {
      value: '',
    },
  };

  handleChange = (e: Event) => {
    if (e.target instanceof HTMLInputElement) {
      const { name, value } = e.target;
      this.setState({ [name]: { value } });
    }
  };

  handleSubmit = (e: Event) => {
    e.preventDefault();
    const { handleClickButton } = this.props;
    const { url } = this.state;
    handleClickButton(url.value);
  };

  render() {
    const { url } = this.state;
    const { store, locale, localValues } = this.props;
    const country = locale && getLocalizedCountry(locale.domainCountry || 'PE',
      this.context.intl.formatMessage, localValues.countriesMap);

    return (
      <section className={classNames(style.scrapFormContentWrap)}>
        {store && <form className={style.scrapFormContent}
                        onSubmit={this.handleSubmit}>
          <img src={amazonLogo}
               alt="Qempo"/>
          <h1>{`${this.context.intl.formatMessage(messages.titlePartOne)} ${store.name} `}
            {`${this.context.intl.formatMessage(messages.titlePartTwo)} ${country}`}</h1>
          <section className={style.inputWrap}>
            <FormattedMessage id='store.scrapInputBlock.input.label'>{
              txt => <p>{txt}:</p>
            }</FormattedMessage>
            <FormattedMessage id='store.scrapInputBlock.amazon.input.url.placeholder'>{
              txt => <input type="text"
                            name='url'
                            value={url.value}
                            className={classNames(inputStyle.input,
                              { [inputStyle.red]: url.errors && url.errors.length })}
                            onChange={this.handleChange}
                            placeholder={txt}/>
            }</FormattedMessage>
            <FormattedMessage id='store.scrapInputBlock.button.quote'>{
              txt =>
                <button type='submit'
                        className={classNames(buttonStyle.btn, buttonStyle.orange)}>
                  <i className={icons.symbolSearch}/><span>{txt}</span>
                </button>
            }</FormattedMessage>
          </section>
        </form>}
      </section>
    )
  }
}

ScrapInputBlock.propTypes = {
  handleClickButton: PropTypes.func.isRequired,
  store: PropTypes.object,
  locale: PropTypes.object.isRequired,
  localValues: PropTypes.object.isRequired,
};

ScrapInputBlock.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/store/components/ScrapInputBlock/ScrapInputBlock.jsx